import { api } from '../utils'

export const getPlaces = params =>
  api.get(`/places`, params).then(res => res?.data)

export const getPlaceDetails = placeId =>
  api.get(`/places/${placeId}/details`).then(res => res?.data)
